var map = {
	"./iso1328-2-2020_fig01_tooth-to-tooth-radial-deviation.png": "6aff",
	"./iso1328-2-2020_fig02_total-radial-composite-deviation.png": "6cbd",
	"./iso1328-2-2020_figB01_double-flank-radial-composite-deviation.png": "95d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f8a";